import baseV3Service from './base/baseV3Service.js';
import baseInsightsService from './base/baseInsightsService.js';

const getRoles = (config) => {
    return baseV3Service.get("roles", config);
};
const getUsers = (config) => {
    return baseV3Service.get("users", config);
};
const getUser = (userId, config) => {
    return baseV3Service.get(`users/${userId}`, config);
};
const getUserInsights = (userId, config) => {
    return baseInsightsService.get(`users/${userId}`, config);
};
const updateUser = (_id, payload, config) => {
    return baseV3Service.put(`users/${_id}`, payload, config);
};
const createUser = (payload, config) => {
    return baseV3Service.post("users", payload, config);
};
const deleteUser = (userId, config) => {
    return baseV3Service.delete(`users/${userId}`, config);
};
const getScannerDetails = (userId, config) => {
    return baseV3Service.get(`users/${userId}/scanner-details`, config);
};
const updateScannerDetails = (userId, payload, config) => {
    return baseV3Service.put(`users/${userId}/scanner-details`, payload, config);
};
const getScanners = (config) => {
    return baseV3Service.get("users/scanners", config);
};

export { createUser, deleteUser, getRoles, getScannerDetails, getScanners, getUser, getUserInsights, getUsers, updateScannerDetails, updateUser };
